module.exports = __webpack_public_path__ + "img/menu.2022da88.svg";